import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { WrapperComponentDirective } from '@rd-lib/whitelabel/wrapper/wrapper.component';

@Component({
  selector: 'rd-core-bypass-block-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BypassBlockWrapperComponent extends WrapperComponentDirective {
  @HostBinding('class.rd-core-bypass-block-wrapper') componentClass = true;
  @Input() isLoggedIn = false;

  componentName = 'core-bypass-block';
}
